export const locale = {
    lang: 'tr',
    data: {
      'PRINCIPAL': {
        'TITULO': 'Anket durumu',
        'SUBTITULO': 'Firmanın bir veya birden fazla ürününde uygulanan anketlerin bilgilerini inceleyebilir ve takip edebilirsiniz.',
        'COPY_URL_RES':'URL yi SuccesGo dan kopyalayın',
      },
      'MENU_PRODUCTOS': {
        'TITULO': 'Satın alınan ürünler',
        'CARGANDO': 'Ürün listesi yükleniyor',
        'NOMBREPULSO': 'Nabız',
        'TIPOS': {
          'certificar': {
            'NOMBRE': 'onayla',
            'SUBTIPOS': {
              'v1': 'v1\'i onayla',
              'v2': 'Sürüm 2.0\'ı onaylayın',
              'v3': 'v3.0\'ı onaylayın',
            }
          },
          'certificacionesAdicio': {
            'NOMBRE': 'Ek sertifikalar',
            'SUBTIPOS': {
              'v1Amco': 'AMCO',
              'v2TD': 'Düzgün iş',
              'v3PE': 'İlk iş',
            }
          },
          'medir': {
            'NOMBRE': 'ölçün',
            'SUBTIPOS': {
              'v1': 'v1\'i ölçün',
              'v2': 'Ölçüm iyileştirildi',
              'v3': 'Ölçü + MST',
              'v4': 'Alanlara göre ölçün',
              'v5': 'Liderlere göre ölçün',
              'v6': 'Boyutlara göre ölçün',
              'v7': 'Onaylamak için ölçü',
              'v8': 'Ölçü 3.0',
            }
          },
          'pulse': {
            'NOMBRE': 'Kontrole basın',
            'SUBTIPOS': {
              'v1': 'Nabız Kontrolü v1.0',
              'v2': 'Nabız Kontrolü v3.0',
            }
          },
          'focus': {
            'NOMBRE': 'Odak Alanı',
            'SUBTIPOS': {
            }
          },
          'nom35': {
            'NOMBRE': 'NOM-035',
            'SUBTIPOS': {
              'v1': 'NOM-035',
              'v2': 'NOM-035 v3',
            }
          },
          'cgoExpress': {
            'NOMBRE': 'Kültürel Go Ekspresi',
            'SUBTIPOS': {
              'cgoExpress': 'Kültürel Go Ekspresi'
            }
          },
          'resulGoFlow': {
            'NOMBRE': 'goFlow sonuçları',
            'SUBTIPOS': {
              'resulGoFlow': 'goFlow sonuçları'
            }
          },
        }
      },
      'DETALLES': {
        'TITULO': 'Ürün Detayları',
        'PRODUCTO': 'Ürün:',
        'PROGRESO': 'İlerleme',
        'RESTANTE': 'Kalan süre',
        'DIASREST': 'Kalan günler:',
        'PANELFIJO': 'Sabit panel olarak göster',
        'SURVEYTOKEN': 'Anket Simgesi',
        'ACCOUNT_ID': 'hesap kimliği',
        'OPORTUNITY_ID': 'fırsat kimliği',
        'FECHAS': {
          'lanzamiento': 'Yayın tarihi',
          'cierre': 'Son teslim tarihi',
          'prorroga': 'Uzatma tarihi',
          'recordatorio':'hatırlatıcılar',
          'avisos':'Anket öncesi iletişim',
        },
        'AVANCES': {
          'NORMAL': 'Ön yanıtlar:',
          'MAS50': '50\'nin üzerinde ilerleyin:',
          'MAS50_2': '50\'den Fazla - Önceden Cevaplar',
          'MENOS50': '50\'den az avans:',
          'MENOS50_2': '50\'den az - Gelişmiş yanıtlar'
        }
      },
      'CONTENIDO': {
        'BOTONES': {
          'VERPROD_1': 'Bir ürün seçin',
          'VERPROD_2': 'Başka bir ürüne bakın',
          'OCULTAR': 'Saklamak'
        },
        'PREVIA': {
          'TITULO': 'Ürüne göre anket durumu',
          'SUBTITULO': 'Bu firmanın satın aldığı ürünlerin listesi bu ekranın solundaki menüde gösterilir. Her ürün için anket durumunu görmek için bir ürün kategorisine tıklayın ve ardından bir yıl seçin. Bundan sonra, seçilen ürünün zaten başlatılmış bir anketi varsa, seçilen anketin ayrıntıları görüntülenecektir.',
          'CARGANDO': 'Seçilen ürünün durumu alınıyor, lütfen bekleyin'
        },
        'ESTADOS': {
          'NOCREADA': 'Bu üründe henüz oluşturulmuş bir anket yok',
          'NOINICIADA': 'Anket etkinleştirilmedi'
        },
      },
      'COLABORADORES': {
        'TAB': 'Ortak çalışanların listesi',
        'CARGANDO': 'Ortak çalışanların listesi yükleniyor',
        'TABLA': {
          'TITULO': 'Ortak çalışanların listesi',
          'NOINFO': 'Bilgi yok',
          'COLUMNAS': {
            'NOMBRE': 'Ad Soyad',
            'EMAIL': 'E-posta',
            'PASS': 'Parola',
            'STATUS': 'Gerçek durum',
            'FECHA_INI': 'Başlangıç ​​tarihi',
            'FECHA_FIN': 'Bitiş tarihi',
            'ACCIONES': 'Hareketler'
          },
          'TOOLTIPS': {
            'ACCIONES': 'Mevcut İşlemler',
            'EMAILS': 'E-posta günlüğü',
          },
        },
        'ACCIONES': {
          'TITULO': 'Mevcut İşlemler',
          'LISTA': {
            'primerosColab': 'İlk 1000\'e bakın',
            'buscarColab': 'Ortak çalışan bul',
            'nuevoColab': 'Yeni ortak çalışan ekle',
            'enviaReco': 'Hatırlatıcı gönder',
            'bajarColab': 'Ortak çalışanların listesini indirin',
          }
        },
        'SENDGRID': {
          'TITULO': 'Gönderilen posta günlüğü',
          'SUBTITULO': 'Gönderilen e-postaların geçmişini göstermek için listeden bir konu türü seçin',
          'SELOPC': 'Bir seçenek seçin',
          'INFOASUNTO': {
            'TITULO': 'Posta bilgileri',
            'CARD': {
              'from': 'Gönderildi',
              'to': 'itibaren',
              'subject': 'Mesaj Konusu'
            },
            'HISTORIAL': {
              'TITULO': 'E-posta gönderme geçmişi',
              'SUBTITULO': 'NOT: Listede görüntülenen tarih/saat, yerel saate göre ayarlanmıştır.',
              'VECESABIERTO': 'Açık saatler',
              'ULTIMOEVENTO': 'Son olay',
              'NORECORDS': 'E-posta geçmişiniz mevcut değil',
              'STATUS': {
                'ABIERTO': 'E-posta gönderildi',
                'NOENVIADO': 'Henüz gönderilmedi'
              }
            }
          },
          'BOTONES': {
            'BACK': 'Geri gitmek'
          }
        },
        'ACCIONESUSUARIO': {
          'TITULO': 'Mevcut İşlemler',
          'SUBTITULO': 'Aşağıdaki liste, kullanıcının kullanabileceği eylemlerin listesini gösterir.',
          'CARGANDO': 'Kullanılabilir eylemler yükleniyor',
          'LISTA': {
            'modificar': 'Seçili ortak çalışanın verilerini değiştirin',
            'borrar': 'Seçili ortak çalışanı sil',
            'invitacion': 'Yeniden gönderme daveti',
            'recordatorio': 'Hatırlatıcıyı yeniden gönder',
            'respuestas': 'Anket yanıtını kaldır',
            'resetSur': 'Anket erişimini sıfırla',
          }
        },
        'MODALES': {
          'BUSCAR': 'Aramak için ortak çalışanın adını girin',
          'BUSCAR_BOT': 'Arama',
          'MINIMARECO': 'Hatırlatıcılar yalnızca anket başlatma tarihinden itibaren gönderilebilir',
          'GENERAEXCEL': 'Ortak çalışanların excel dosyası oluşturuluyor, bir dakika bekleyin',
          'NOANSWERS': 'Bu katılımcı için yanıt bulunamadı',
          'ENVIOCORREO': 'Mesaj gönderiliyor, bir dakika bekleyin',
          'BORRARESP': 'Bu kullanıcıdan gelen yanıtlar siliniyor, lütfen biraz bekleyin',
        },
        'EXCEL': {
          'TITUARCHIVO': 'Ortak çalışanların listesi',
          'COLUMNAS': {
            'name': 'Ortak çalışan adı',
            'email': 'E-posta',
            'id_status': 'Anket durumu',
            'start_date': 'Başlangıç ​​tarihi',
            'end_date': 'Bitiş tarihi',
          }
        }
      },
      'ACCIONES': {
        'TAB': 'Hareketler',
        'TITULO': 'Kategoriye göre kullanılabilen eylemlerin listesi',
        'CATEGORIAS': {
          'encuesta': 'anket',
          'filemanager': 'Dosya yöneticisi',
          'resultados': 'Sonuçlar',
          'webcompro': 'web de şirket profili'
        },
        'LISTA': {
          'surveyCheck': 'Anketi kontrol etme',
          'surveyDown': 'Anketi indir',
          'goSurvey': 'Ankete git',
          'goCounting': 'Counts Portal\'a gidin',
          'goCounting_more50': 'Sayım Portalına Git +50',
          'goCounting_less50': 'Sayım Portalına Git -50',
          'genCountingUrl': 'Counts Portal\'a harici bağlantı oluşturun',
          'copyCountingUrl': 'Dış bağlantıyı Counts portalına kopyalayın',
          'updateCounting': 'Counts portalı ile senkronize edin',
          'addPro': 'Uzantı eklemek',
          'verRecord': 'Kayıtlı hatırlatıcılar',
          'surveyClose': 'Anketi kapat',
          'surveyOpen': 'Anketi aç',
          'processRes': 'Süreç sonuçları',
          'goPriv': 'Özel klasörü görüntüle',
          'goPub': 'Ortak klasörü görüntüle',
          'verRes': 'Sonuçları görüntüle',
          'upNameIcon': 'Adı ve logoyu güncelle',
          'regCertifi': 'Sertifikayı yeniden oluştur',
          'goSurveyMas50': 'Anket +50 ye git',
          'goSurveyMenos50': 'Anket -50 ye git',
          'auditMan': 'Manuel denetim',
          'libeCultureBrief': 'Kültür Kısa Yayın',
          'lockRes': 'Sonuçları kilitle',
          'verCultureAudit': 'Kültür Denetimine Bakın',
          'verAvisos':'Anket öncesi iletişim',
          'enviaCorreos': 'E-postaları manuel olarak gönder',
          'verWebComPro': 'Web de şirket profilini görüntüleyin',
          'verFechIniCie': 'Başlangıç / bitiş tarihi',
          'cancelarEnvios': 'E-posta göndermeyi iptal et',
          'verConfigResult': 'Sonuç yapılandırması',
          'descaDemo': 'Demografinin indirilmesine izin ver',
          'crearClave':'Harici şirket profili için anahtar oluştur',
          'copyClave':'Anahtarı harici şirket profiline kopyalayın',
          'verDatWPC':'Harici şirket profili erişim verilerini görüntüleyin',
          'confirReviCultureAudit':'Kültürel denetim incelemesini onaylayın',
        },
        'MODALES': {
          'URL': 'link kopyalandı',
          'URL_CLA': 'Anahtar panoya kopyalandı',
          'CHANGE_RESULT':'Sonuçlar yükleniyor',
          'LOADINGMASTER': 'Ana Tablodan bilgi alınıyor, lütfen biraz bekleyin',
          'CONFIR_UPDA_NAM':'Adı ve logoyu güncellemek istediğinizden emin misiniz?',
          'CONFIR_REG_CERT':'Sertifikayı yeniden oluşturacağınızdan emin misiniz?',
          'SUCC_UPDA_NAME':'Başarıyla güncellendi',
          'UPDA_NAME_ICON':'Veriyi güncelle',
          'UPDA_STA_ENC':'Encuesta nın gerçek durumu',
          'OBT_DAT_AUD_AUT':'Denetim bilgilerinin alınması',
          'WARNI_NOT_EXIT_TOKEN':'Hata: jeton MT de mevcut değil',
          'CONFIR_REPRO_RESULT':'Sonuçları yeniden işlemek istediğinizden emin misiniz?',
           'MOD_INGRE_COD_PT1':'<span> Onaylamak için kodu kırmızı metin kutusuna girin ',
           'MOD_INGRE_COD_PT2':'</span>',
           'ERROR_CODIGO': 'Girilen kod kırmızı ile gösterilen kodla eşleşmiyor',
           'CONFIR_LIBE_CULT_BRI':'Kültür özetini yayınlayacağınızdan emin misiniz?',
           'CONFIR_REVI_CULT_AUDIT':'Kültür denetim incelemesini onaylayacağınızdan emin misiniz?',
           'NO_CONFIR_REVI_CULT_AUDIT':'Kültür denetimi incelemesini iptal etmek istediğinizden emin misiniz?',
           'NO_CULT_BRI_ASOC':'İlişkili kültür denetimi bulunamadı',
           'BLOQUEAR_1_1': 'Sonuçların kilidi şu anda açık\nSonuçları kilitlemek istiyor musunuz?',
           'BLOQUEAR_1_2': 'Sonuçların engellenme nedenini girin',
           'BLOQUEAR_2_1': 'Sonuçlar şu anda kilitli \nSonuçların kilidini açmak istiyor musunuz?',
           'BLOQUEAR_2_2': 'Sonuçların kilidinin açılmasının nedenini yazın',
           'BLOQUEAR_3_1': 'Değişikliğin nedenini belirtmek gerekir',
           'SINCRONIZARMT': 'Ana Tablonun verileri senkronize ediliyor, lütfen biraz bekleyin',
           'UPDA_DAT_RECOR': 'Hatırlatma tarihini güncelle',
           'DELE_DAT_RECOR': 'Hatırlatma tarihini sil',
           'UPDA_DAT_AVI': 'Bildirim Tarihi Güncellemesi',
           'DELE_DAT_AVI': 'İhbar tarihini ortadan kaldırmak',
           'CANCELAR_ENVIOS': 'Planlanmış e-postaları iptal etmek istediğinizden emin misiniz?',
           'CANCELAR_ENVIOS_OK': 'Sevkiyat başarıyla iptal edildi.',
           'CANCELAR_ENVIOS_ERROR': 'Anketin başlamasına iki saat kala teslimatı iptal etmek mümkün değildir.',
           'COM_CRE_ACCE_WCP_EXT': 'Şirket profili için anahtarı oluşturduğunuzdan emin misiniz?',
           'CRE_ACCE_WCP_EXT': 'Parola oluşturuluyor',
           'SUCC_CRE_ACCE_WCP_EXT': 'Parola başarıyla oluşturuldu',
           'TIT_MOD_VALI_ACCE_WCP_EXT': 'Devam etmek için: Parolanızı girin',
           'PLA1_MOD_VALI_ACCE_WCP_EXT': 'Şu anda ',
           'PLA2_MOD_VALI_ACCE_WCP_EXT': ' deneme hakkınız kaldı',
           'BTN_ACEP': 'Kabul etmek',
           'BTN_CAN': 'İptal etmek',
           'WAR_ACCE_WCP_EXT': 'Girilen şifre doğru değil',
           'LIMI_ACCE_WCP_EXT': 'Deneme sınırına ulaştınız',
           'DESAC_ACCE_WCP_EXT': 'Şirket profiliniz şu anda devre dışı',
           'ACTU_ACCE_WCP_EXT': 'Bilgi güncelleniyor',
           'SUCC_ACTU_ACCE_ACCE_WCP_EXT': 'Başarıyla güncellendi',
           'CHANGE_WCP':'Şirket profili yükleniyor',
        },
        'SUBACCIONES': {
          'TITULO': 'Daha fazla kullanılabilir eylem görmek için burayı tıklayın',
          'AUDMANUAL': {
            'TITULO': 'Manuel denetim',
            'NOMBRE': 'Denetçinin adı',
            'NOTAS': 'gözlemler',
            'STATUS': {
              'ON': 'Denetim kabul edildi',
              'OFF': 'Denetim reddedildi'
            }
          },
          'verRes': {
            'tipoResu': {
              'TITULO': 'Sonuç sürüm türünü değiştir',
              'MODAL': {
                'TITULO': 'Sürüm türü seçimi',
                'SUBTITULO': 'Bu ürün için sonuç sürümünün türünü seçin',
                'SINCERT': 'Sertifikasız sürüm',
                'CONCERT': 'Sertifikalı sürüm'
              }
            },
            'tipoResuV2': {
              'TITULO': 'Sonuçlara bakın sürüm 2',
            },
          },
          'regCertifi': {
            'logoCert': {
              'TITULO': 'Sertifika logosunu değiştir',
            },
            'previewCert': {
              'TITULO': 'Sertifika önizlemesi',
            },
            'multiSite': {
              'TITULO': 'Çoklu site sertifika metnini etkinleştir',
            },
            'multiSiteText': {
              'TITULO': 'Çoklu site sertifika metnini görüntüle',
            },
          },
          'upNameIcon': {
            'logoEmpresa': {
              'TITULO': 'Şirket logosunu değiştir'
            },
            'previewLogoEmp': {
              'TITULO': 'Logo önizlemesi'
            },
            'updateDatCerti': {
              'TITULO': 'Sertifika tarihini değiştir',
            }
          },
          'masterTable': {
            'syncMT': {
              'TITULO': 'Ana Tabloyu Senkronize Et'
            }
          },
          'crearClave': {
            'visibleSwitchWCP': {
              'TITULO': 'Durum, harici şirket profiline bakın',
            }
          },
          'verDatWPC': {
            'visibleSwitchWCP': {
              'TITULO': 'Durum, harici şirket profiline bakın',
            }
          },
          'verWebComPro': {
            'updateStatusWCP': {
              'TITULO': 'Durum web sitesinde şirket profiline bakın',
            },
            'ESTA_WPC':{
              'ESTA_WPC_PU':'Halk',
              'ESTA_WPC_NPU':'halka açık olmayan',
            },
          },
        }
      },
      'HISTORIAL_MAILS': {
        'TAB': 'Gönderilen e-postaların geçmişi',
        'TITULO': 'Bu ürün için gönderilen e-postaların listesi',
        'TABLA': {
          'DESTINATARIO': 'muhatap',
          'ASUNTO': 'Posta konusu',
          'ESTADO': 'Şu anki durum',
          'VECES': 'Açılma sayısı',
          'ULTIMO': 'Son etkinliğin tarihi',
          'FILTRO': 'Filtre',
          'INPUT_DEST': 'E-posta adresine göre filtrele',
          'INPUT_ASU': 'Konuya göre filtrele',
          'INPUT_STAT': 'Duruma göre filtrele',
          'ELIJAOPCION': '- Listeden bir seçenek belirleyin -',
          'NORESULTS': 'kayıt bulunamadı',
          'LISTA_STATUS': {
            'delivered': 'gönderildi',
            'processed': 'Nakliye sürecinde',
            'not_delivered': 'Gönderilmedi'
          }
        },
        'ACCIONES': {
          'TITULO': 'Mevcut İşlemler',
          'LISTA': {
            'enviaCorreos': 'E-postaları manuel olarak gönder',
            'getEnviados': 'E-posta gönderme geçmişini güncelle',
          }
        },
        'MODAL': {
          'TITULO': 'Manuel postalama',
          'SUBTITULO': 'Bu ankette ortak çalışanlara belirli bir türde manuel postaları anında gönderebilirsiniz.',
          'INPUT': 'Bir posta türü seçin',
          'TIPOS': {
            '1': 'davet e-postası',
            '2': 'hatırlatma e-postası',
            '3': 'Anketi başlatmadan önce ilk bildirim',
            '4': 'Anketi başlatmadan önceki ikinci bildirim',
            '5': 'Kapanış Postası',
            '6': 'Henüz ankete başlamamış ortak çalışanlara gönderilen posta',
            '7': 'Başlayan ancak henüz bitirmemiş olan ortak çalışanlara gönderilen posta'
          },
          'BOTONES': {
            'BACK': 'Geri gitmek',
            'CONTINUAR': 'Devam etmek',
            'SAVE': 'Denetimi kaydet',
          }
        },
        'MODALES': {
          'RECUPERANDO': 'Gönderilen postalar listesi alınıyor, bir dakika bekleyin',
          'SEND_EMA':'Posta gönderme',
          'SUCC_SEND_EMA':'Postalar başarıyla gönderildi',
          'CONFIRMAR': 'Seçilen türdeki e-postaları bu ankette ortak çalışanlara göndermeyi onaylıyor musunuz?',
          'ENVIADOS': 'E-postalar başarıyla gönderildi, gönderilen e-postaları görmek için kısa süre içinde geçmişi güncelleyin',
          'SI': 'Evet',
          'NO': 'Numara',
          'UPDAT_HIST_EMA': 'Geçmiş güncelleniyor',
          'SUCC_UPDAT_HIST_EMA': 'Başarıyla güncellendi',
          'WAR_SEL_MAI': 'Devam etmek için bir posta türü seçin',
          'WAR_SQL_ERROR': 'Yanıt süresi doldu, lütfen tekrar deneyin',
        },
        'RESUMEN': {
          'TITULO': 'Özet',
          'TIPOS': {
            'totalEnviados': 'Toplam postalama başladı',
            'delivered': 'Doğru postalar',
            'processed': 'İşlemdeki postalar',
            'not_delivered': 'Postalar yapılmadı',
          }
        }
      },
      'AUDITORIA':{
        'TAB_TIT_AUDI':'Anket denetimi',
        'TEX_AUDI_NOT_AUTORI': 'Denetim reddedildi!',
        'TEX_AUDI_YE_AUTORI':'Denetim kabul edildi!',
        'TITL_AUDI_DEV_TR':'% Dev.Time Yanıtı',
        'TITL_AUDI_DEV_PC':'% Dev. Soru Kontrolü',
        'TITL_AUDI_DEV_PA':'% Dev. Soru Rastgele',
        'TIT_PAGI_TABL':'Sayfa başına makaleler:',
        'COLUMNAS':{
          'HierarchicalPath':'Yapı',
          'RespondentCount':'# Cevaplar',
          'Time_DeviationCount':'# Desv T.Resp',
          'Time_DeviationPercentage':'% Desv T.Resp',
          'ControlStatement_DeviationCount':'# Desv P.Kontrol',
          'ControlStatement_DeviationPercentage':'% Desv P.Kontrol',
          'RandomStatement_DeviationPercentage':'# Desv P.Aleatoryum',
          'RandomStatement_DeviationCount':'% Desv P.Aleatoryum',

        }
      },
      'EMAI_LOG':{
        'TAB':'Genel posta geçmişi',
         'TABLA_GLOBAL':{
           'TITU':'Küresel ekran',
           'SUB_TIT':'Toplam katkıda bulunanlar',
           'TH_1':'Durum',
           'TH_2':'İlk bildirim',
           'TH_3':'İkinci bildirim',
           'TH_4':'Davet',
           'TH_5':'Başlamamış kullanıcılara hatırlatma',
           'TH_6':'Bitmemiş kullanıcılar için hatırlatma',
           'enviados':'Gönderildi',
           'procesando':'İşleniyor',
           'error':'Hata',
           'VIE_DETA_TOOL':'Detayları göster',

        },
        'TABLA_COLAB':{
          'TITU_AV1_DELIV': 'Gönderilen uyarının görüntülenmesi 1 tür posta',
          'TITU_AV1_PROCC':'Posta türü bildirimi 1 işleniyor',
          'TITU_AV1_N_DELIV':'E-posta uyarısı tipini görüntüle 1 hatalı',

          'TITU_AV2_DELIV': 'Gönderilen posta uyarısının türünü görüntüle',
          'TITU_AV2_N_DELIV':'E-posta uyarısı 2 türünü hatalı görüntüle',
          'TITU_AV2_PROCC': 'Görüntüleme tipi 2 bildirim 2 postası işleniyor',

          'TITU_INV_DELIV':'Gönderilen posta davetiyesinin türünü görüntüle',
          'TITU_INV_PROCC': 'İşlemdeki davet postasının türünü görüntüle',
          'TITU_INV_N_DELIV': 'Hatalı davet postasının türünü görüntüle',

          'TITU_REC1_DELIV':'Hatırlatıcı posta türü 1 gönderildi',
          'TITU_REC1_PROCC':'Hatırlatıcıyı görüntüle 1 tür posta işlemde',
          'TITU_REC1_N_DELIV':'Hatalı 1 tür posta hatırlatıcısını göster',

          'TITU_REC2_DELIV':'Hatırlatıcı posta türü 2 gönderildi',
          'TITU_REC2_N_DELIV':'Hatalı hatırlatıcı posta türü 2 yi görüntüle',
          'TITU_REC2_PROCC': 'Hatırlatıcı posta türü 2 işlemde görüntüle',
          'SUB_TIT':'Toplam ortak çalışan',
          'TH_1':'Durum',
          'TH_2':'Katkıda bulunan adı',
          'TH_3':'Mesaj',
          'TH_4':'Son e-postanın tarihi',
          'TH_5':'Toplam posta',
          'TH_6':'Eylem',
          'processed':'Processed',
          'delivered':'Delivered',
          'open':'Open',
          'bounce':'Bounced',
          'dropped':'Dropped',
          'TEX_SEARC_COLAB':'Ad veya e-posta girin',

         },
         'TEX_MOD_CHA_INFO':'Bilgi yükleniyor',
        'CONT_MOD':{
          'TAB_TIT1':'Posta durumu',
           'TAB_TIT2':'Posta görünümü',
           'TEX_CHA_INFO_GRAL':'Bilgi yükleniyor',
           'TEX_ASUN':'Konu: ',
           'TEX_SELEC_EMA':'Bir e-posta seçin',
           'TEX_CHA_INFO_EMA':'Posta bilgileri yükleniyor',
           'H1_TIT_EMA_INFO':'E-posta bilgileri',
           'SPAN_SUB_TIT_DET':'ayrıntılar',
           'TO':'Kime:',
           'FROM':'Kimden:',
           'SUBJE':'Konu',
           'MESS_ID':'Mesaj Kimliği :',
           'BTN_VER_MAS':'Daha fazla ayrıntı',
           'BTN_VER_MEN':'Daha az ayrıntı',
           'TIT_TEX_LIS':'Etkinlik Geçmişi',
           'SPAN_RECIV_SENGR':'SendGrid tarafından alındı',
           'SPAN_RECIV_FROM':'Tarafından alınan ',
          'processed':'Processed',
          'delivered':'Delivered',
          'open':'Open',
          'bounce':'Bounced',
          'dropped':'Dropped',
          'deferred':'Deferred',
          'blocked':'blocked',
          'SPAN_DES_OPE_EMA':'Alıcı bu postayı açtı',
          'REASON':{
           'Bounced Address':'Geri Dönen Adres',
          }

        }
      },
      'DAT_CERTI':{
        'TIT_MOD':'Sertifika tarihini değiştir',
         'ING_DAT':'Tarih seçin:',
         'ING_RAS':'Tarihi değiştirme nedenini girin:',
         'BTN_SAV':'Değişiklikleri kaydet',
         'BTN_OK':'Tamam',
         'MOD_ING_REA':'Tarih değişikliği nedenini girin',
         'MOD_UPD_DAT':'Sertifika tarihi güncelleniyor',
         'SUCC_MOD_UPD_DAT':'Başarıyla güncellendi',

      },
      'DAT_STAEND':{
        'TIT_MOD':'Anket başlangıç ve bitiş tarihi',
         'SUB_TIT_MOD':'Her tarih yerel saate göre ',
         'TEX_DA_STA':'Başlangıç tarihi',
         'TEX_DA_EN':'Bitiş tarihi',
         'MOD_UPD_DA_DA_STA':'Yayın tarihi güncelleniyor',
         'MOD_UPD_DA_EN':'Bitiş tarihi güncelleniyor',
         'SUCC_MOD_UPD_DA_DA_STA':'Başarıyla güncellendi',
         'SUCC_MOD_UPD_DA_DA_EN':'Başarıyla güncellendi',

      },
      'LANG_CERT':{
        'TIT_MOD':'Dil Seçin:',
      },
    }
};
